import { render, staticRenderFns } from "./CreateHandsel.vue?vue&type=template&id=5b929a70&scoped=true"
import script from "./CreateHandsel.vue?vue&type=script&lang=js"
export * from "./CreateHandsel.vue?vue&type=script&lang=js"
import style0 from "./CreateHandsel.vue?vue&type=style&index=0&id=5b929a70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b929a70",
  null
  
)

export default component.exports